import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
export default function OrderInMinutes({
  className,
  fillPrimary = colors.neutral100,
  fillSecondary = colors.aqua50,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M22 46.5H7.5C5.9087 46.5 4.38258 45.8679 3.25736 44.7426C2.13214 43.6174 1.5 42.0913 1.5 40.5V7.5C1.5 5.9087 2.13214 4.38258 3.25736 3.25736C4.38258 2.13214 5.9087 1.5 7.5 1.5H26.5C28.0913 1.5 29.6174 2.13214 30.7426 3.25736C31.8679 4.38258 32.5 5.9087 32.5 7.5V13.5"
        stroke={fillPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 37H15"
        stroke={fillPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45 35.1929L40.7593 31.0049C39.8883 30.1452 38.7367 29.6182 37.5092 29.5179C36.2817 29.4176 35.0579 29.7504 34.0556 30.457L31.2042 32.4689L27.5237 28.8373C27.2865 28.5807 26.9991 28.3742 26.6787 28.2304C26.3584 28.0866 26.0119 28.0084 25.6601 28.0006C25.3082 27.9929 24.9585 28.0556 24.6319 28.1851C24.3054 28.3146 24.0089 28.5081 23.7603 28.7539C23.5117 28.9998 23.3162 29.2929 23.1857 29.6155C23.0551 29.9381 22.9922 30.2835 23.0008 30.6307C23.0093 30.978 23.0892 31.32 23.2355 31.6359C23.3817 31.9519 23.5914 32.2352 23.8518 32.4689L30.2901 38.8245L28.1307 39.535C27.4629 39.7522 26.9004 40.2063 26.5523 40.8094C26.2041 41.4125 26.095 42.1216 26.2461 42.7995C26.3973 43.4774 26.7978 44.0759 27.3703 44.479C27.9427 44.8821 28.6463 45.0611 29.3448 44.9815L35.8109 44.2726"
        stroke={fillSecondary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6 23C26.9713 23 27.3274 22.8525 27.5899 22.5899C27.8525 22.3274 28 21.9713 28 21.6V19.4991C27.9997 19.0513 27.8218 18.622 27.5053 18.3053L25.2 16H9.8L7.49467 18.3053C7.17819 18.622 7.00028 19.0513 7 19.4991V21.6C7 21.9713 7.1475 22.3274 7.41005 22.5899C7.6726 22.8525 8.0287 23 8.4 23H26.6Z"
        stroke={fillPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 16L11.5457 10.7033C11.692 10.2025 11.954 9.77093 12.2967 9.4665C12.6395 9.16207 13.0465 8.9993 13.4634 9H21.5394C21.9557 9.00002 22.3622 9.16312 22.7044 9.4675C23.0466 9.77188 23.3082 10.203 23.4543 10.7033L25 16H10Z"
        stroke={fillPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15.5L8.5 14H7"
        stroke={fillPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.25 15.5L25.75 14H27.25"
        stroke={fillPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25 23V24.5C9.25 24.8978 9.40804 25.2794 9.68934 25.5607C9.97064 25.842 10.3522 26 10.75 26C11.1478 26 11.5294 25.842 11.8107 25.5607C12.092 25.2794 12.25 24.8978 12.25 24.5V23H9.25Z"
        stroke={fillPrimary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="19.5" r="1" fill={fillPrimary} />
      <circle cx="23" cy="19.5" r="1" fill={fillPrimary} />
    </svg>
  );
}
